import About from './About';

export default About;



// WEBPACK FOOTER //
// ./src/pages/static/About/index.jsx